/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import Responsive from 'app/components/responsive/Responsive';
import t from 'app/utils/translate';

type Props = {
  salaryCap?: number,
  salaryExpenditure: number
};

const SalaryStatusTitle = styled.div(({ theme }) => ({
  color: theme.color.basis5,
  fontSize: theme.fontSize.tiny,
  justifyContent: 'center',
  textAlign: 'center',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  [theme.mediaQuery.desktopAndUp]: {
    paddingBottom: theme.spacing.xsmall
  }
}));

const SalaryUtilisationBar = styled.div(({ theme }) => ({
  backgroundColor: theme.color.panelAccent,
  [theme.mediaQuery.desktopAndUp]: {
    borderRadius: theme.borderRadius.small,
    marginBottom: theme.spacing.small
  }
}));

const SalaryUtilisationBarProgress = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundImage: `linear-gradient(to right, 
    ${theme.getSkin(
      'SalaryUtilisationBarProgress.color1',
      theme.color.secondary3
    )}, ${theme.getSkin('SalaryUtilisationBarProgress.color2', theme.color.secondary2)})`,
  color: 'white',
  display: 'flex',
  flexDirection: 'row',
  fontSize: theme.fontSize.tiny,
  height: 5,
  justifyContent: 'flex-end',
  transition: 'all 0.3s ease-in-out',
  width: '100%',
  transformOrigin: 'left',
  [theme.mediaQuery.desktopAndUp]: {
    height: 22,
    borderRadius: theme.borderRadius.small,
    width: 'inherit'
  }
}));

const SalaryUtilisationBlock = styled.div({
  flexGrow: 1,
  position: 'relative',
  textTransform: 'uppercase'
});

const SalaryUtilisationLabel = styled.span({
  paddingRight: 4
});

const defaultProps = {
  salaryCap: undefined
};

function SalaryUtilisation({ salaryCap, salaryExpenditure }: Props) {
  const salaryUtilisation = Math.floor((salaryExpenditure * 100) / salaryCap);

  return (
    <SalaryUtilisationBlock>
      <Responsive desktop>
        <SalaryStatusTitle>{t('Salary Utilisation')}</SalaryStatusTitle>
      </Responsive>
      <SalaryUtilisationBar>
        <Responsive desktop>
          {isDesktop => (
            <SalaryUtilisationBarProgress
              style={
                isDesktop
                  ? {
                      width: `${Math.min(salaryUtilisation, 100)}%`
                    }
                  : {
                      transform: `scaleX(${salaryUtilisation / 100})`
                    }
              }
            >
              {salaryUtilisation > 0 && isDesktop && (
                <SalaryUtilisationLabel>{salaryUtilisation}%</SalaryUtilisationLabel>
              )}
            </SalaryUtilisationBarProgress>
          )}
        </Responsive>
      </SalaryUtilisationBar>
    </SalaryUtilisationBlock>
  );
}

SalaryUtilisation.defaultProps = defaultProps;

export default SalaryUtilisation;
